export const dataUrl = "/en.model.json"
export const searchDataUrl = "/search.model.json"
export const cartDataUrl = "/en/cart.model.json"
export const GLOBAL_CONFIGURATION_PATH =
  "/bin/kohler/services/globalconfig.kohler.json"

export const headerUrl =
  "/content/experience-fragments/kohler/us/en/navigation/header/global-header-experience-fragment/master"
export const footerUrl =
  "/content/experience-fragments/kohler/us/en/navigation/footer/Global-footer-experience-fragment/master"

export const pageUrl = "/en/"
export const cartPage = pageUrl + "cart"
export const checkoutDataUrl = "/en/checkout.model.json"
export const sharedCartUrl = "/en/cart/shared-cart.model.json"
export const orderConfirmationDataUrl =
  "/en/orders/order-confirmation.model.json"
export const orderDetailsPageDataUrl = "/en/orders/order-details.model.json"
export const orderHistoryPageDataUrl = "/en/orders/order-history.model.json"
export const orderStatusPageDataUrl = "/en/orders/order-status.model.json"
export const returnSlipPageDataUrl = "/en/returns/return-slips.model.json"

export const PRODUCT_DATA_URL = `/products/product-details.model.json`
export const MyProductsPageDataUrl = "/my-account/my-products.model.json"
export const loveYourLookDataUrl = "/en/love-your-look.model.json"
export const pageNotFoundDataUrl = "/error-handler-pages/404.model.json"
export const accountSettingsPageDataUrl =
  "/my-account/account-settings.model.json"
export const MyServicePageDataUrl = "/my-account/my-services.model.json"
export const MyFavoritesPageDataUrl = `/my-account/my-favorites.model.json`
export const MyListsPageDataUrl = `/my-account/my-lists.model.json`
export const REGISTER_OFFLINE_PRODUCTS_DATA_URL = `/my-account/product-registration/register-offline-product.model.json`
export const REGISTER_ONLINE_PRODUCTS_DATA_URL = `/en/my-account/product-registration/register-online-product.model.json`

export const FAQ_PAGE_DATA_URL = "/support/help-and-faq"
export const browseAllStoresURL = "/en/locations/browse-all-stores.model.json"
export const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json"
export const TECHNICAL_SPECIFICATION_DATA_URL =
  "/en/for-professionals/technical-specifications.model.json"
export const PRESS_LANDING_URL = "/en/press-room.model.json"
export const FIND_STORE_URL = "en/locations.model.json"
export const ARTICLE_CONTENT_END_POINT = "/jcr:content.json"
export const ARTICLE_IMG_END_POINT = "/jcr:content/image.json"
export const tooltip = "/icons/tooltip-red.svg"
